import { QueryFactory } from "../../../../Common";
export const QGetEventsByRegionIdAndSportId = QueryFactory("GetEventsByRegionIdAndSportId");
//# sourceMappingURL=QGetEventsByRegionIdAndSportId.js.map